import { OptionLike } from "helpers/OptionHelper";
import { BaseModel } from "./BaseModel";
import { VehicleCategoryData } from "./types";

export class VehicleCategory extends BaseModel<VehicleCategoryData> {
	id: string;
	name: string;
	code: string;

	constructor(data: VehicleCategoryData) {
		super(data);
		this.id = data.id;
		this.name = data.name;
		this.code = data.code;
	}

	toOption = (): OptionLike & VehicleCategory => {
		return { ...this, label: this.name, value: this.id };
	};
}
